var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53454 13.0601C7.99564 13.0611 9.4148 12.5703 10.5628 11.6653L14.893 15.9955L16 14.8884L11.6698 10.5583C12.8932 8.99614 13.3411 6.96256 12.885 5.03125C12.4299 3.0998 11.1209 1.48049 9.32823 0.629498C7.53554 -0.220423 5.45306 -0.209191 3.66959 0.660108C1.88611 1.52941 0.594474 3.16191 0.158791 5.09843C-0.275872 7.03397 0.192463 9.0624 1.43316 10.6111C2.67285 12.1599 4.55033 13.0608 6.53467 13.0598L6.53454 13.0601ZM6.53454 1.56723C7.85075 1.56723 9.11287 2.08963 10.0435 3.02118C10.9751 3.95171 11.4975 5.21383 11.4975 6.53015C11.4975 7.84647 10.9751 9.10848 10.0435 10.0391C9.11298 10.9707 7.85086 11.4931 6.53454 11.4931C5.21822 11.4931 3.9562 10.9707 3.02557 10.0391C2.09403 9.10859 1.57162 7.84647 1.57162 6.53015C1.57162 5.21383 2.09403 3.95181 3.02557 3.02118C3.9561 2.08963 5.21822 1.56723 6.53454 1.56723Z",
    fill: "#9A9FA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.09182e9ac7bf686c3c7a325d5ada5258.svg";
export { ForwardRef as ReactComponent };